import React from 'react';
import * as cls from './footer-ctas.module.css';
import { ROUTES_PATHS } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { Link } from 'react-router-dom';
import { Button } from '../../../../ui/components/button';

export const FooterCTAs = () => {
  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Start Integrating Today
      </Typography>
      <Typography>
        Connect your product to Voltaware’s energy intelligence layer.
      </Typography>
      <Typography>
        Whether you’re building an energy app, platform, or utility dashboard -
        Voltaware gives you the foundation to power intelligent energy
        experiences.
      </Typography>
      <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
        <Button>Book Demo</Button>
      </Link>
    </Section>
  );
};
